import f from "../funcs";
import $ from "jquery";
import Events from "./Events";
import "plugins/hasChild";


let _dragDrops = {};
function eachDragDrop(func) {
    let result;
    for (let id in _dragDrops) {
        result = func(_dragDrops[id]);
        if ( result === false ) {
            return;
        }
    }
}
let index = 0;

let StartEvent = f.CreateClass("StartEvent");
StartEvent.prototype.init = function(e, dragDrop) {
    let $elem = dragDrop.$elem;
    if ( !$elem ) {
        return;
    }

    this._data = {};
    this.point = f.getMousePoint(e);
    this.x = this.point.x;
    this.y = this.point.y;
    this.$elem = $elem;
    this.target = e.target;
    this.$target = $(e.target);
    this.$event = e;
    this._moved = false;
    this.event = e.originalEvent;
    this.dragDrop = dragDrop;
    this.ctrlKey = e.ctrlKey;
    $elem.data("plugin.DragDrop." + dragDrop.id + "." + this.constructor.className, this);
};

StartEvent.prototype.set = function(key, value) {
    this._data[key] = value;
};

StartEvent.prototype.get = function(key) {
    return this._data[key];
};

StartEvent.prototype.cancel = function() {
    this.dragDrop.cancel();
};

let MoveEvent = StartEvent.extend("MoveEvent");
MoveEvent.prototype.init = function(e, dragDrop) {
    let $elem = dragDrop.$elem;
    if ( !$elem ) {
        return;
    }

    StartEvent.prototype.init.call(this, e, dragDrop);
    this.start = $elem.data("plugin.DragDrop." + dragDrop.id + ".StartEvent");
    this.firstMove = $elem.data("plugin.DragDrop." + dragDrop.id + ".FirstMoveEvent");

    this.dx = this.x - this.start.x;
    this.dy = this.y - this.start.y;
    this._moved = true;

    if ( this.dx !== 0 || this.dy !== 0 ) {
        this.start._moved = true;
    }
};

let EndEvent = MoveEvent.extend("EndEvent");
let FirstMoveEvent = MoveEvent.extend("FirstMoveEvent");
let DelayDownEvent = MoveEvent.extend("DelayDownEvent");
let DropEndEvent = MoveEvent.extend("DropEndEvent");
let DropEvent = MoveEvent.extend("DropEvent");

// ===========
class DragDrop extends Events {
    constructor(params) {
        super();

        this.params = f.deepMixin({
            touch: true,
            mouse: true,
            delay: 400,
            $el: false
        }, params);

        this.id = ++index;
        _dragDrops[this.id] = this;

        // элемент, с которого будем начинать start
        this.$elem = null;
        // если перетаскивать начали,
        // то ставим в true
        this.isActive = false;

        // элемент, который перетаскиваем,
        // он закрывает другие элементы,
        // поэтому мы будем его скрывать
        this.$mover = null;

        if ( this.params.$el ) {
            this.addElem(this.params.$el);
        }
    }

    setMover($mover) {
        this.$mover = $mover;
    }

    addElem($el) {
        $el = f.checkElem($el);
        $el.data("plugin.DragDrop", this);
        this.$elem = $el;
    }

    cancel() {
        this.isActive = false;
        clearTimeout(this._delayDownTimer);
    }

    destroy() {
        if ( this.$elem ) {
            this.$elem.data("plugin.DragDrop." + this.id + ".StartEvent", null);
            this.$elem.data("plugin.DragDrop." + this.id + ".MoveEvent", null);
            this.$elem.data("plugin.DragDrop." + this.id + ".EndEvent", null);
            this.$elem.data("plugin.DragDrop", null);
        }

        delete _dragDrops[this.id];
        this.clearEvents();
        delete this.$elem;
    }

    _document_onStart(e) {
        clearTimeout(this._delayDownTimer);
        let target = e.target;


        let $elem = this.$elem;


        let elem = $elem[0];

        if (
            !$elem.hasChild(target)
                && elem != target
        ) {
            return;
        }

        if ( this.params.touch === false && e.type == "touchstart" ) {
            return;
        }

        if ( this.params.mouse === false && e.type == "mousedown" ) {
            return;
        }

        this.start(e);
    }

    _document_onMove(e) {
        clearTimeout(this._delayDownTimer);
        if ( !this.isActive ) {
            return;
        }

        if ( this.params.touch === false && e.type == "touchmove" ) {
            return;
        }

        if ( this.params.mouse === false && e.type == "mousemove" ) {
            return;
        }

        this.move(e);
    }

    _document_onEnd(e) {
        clearTimeout(this._delayDownTimer);
        if ( !this.isActive ) {
            return;
        }

        if ( this.params.touch === false && e.type == "touchend" ) {
            return;
        }

        if ( this.params.mouse === false && e.type == "mouseup" ) {
            return;
        }

        this.end(e);
        this.isActive = false;
    }

    start(e, options) {
        let startEvent = new StartEvent(e, this);
        this.isActive = true;
        this.trigger("start", startEvent, options);

        this._delayDownTimer = setTimeout(function() {
            let delayDownEvent = new DelayDownEvent(e, this);

            this.trigger("delayDown", delayDownEvent, options);
        }.bind(this), this.params.delay);
    }

    move(e, options) {
        let moveEvent = new MoveEvent(e, this);

        if ( !moveEvent.start._firstMove ) {
            moveEvent.start._firstMove = new FirstMoveEvent(e, this);
            moveEvent.firstMove = moveEvent.start._firstMove;
            this.trigger("firstMove", moveEvent.start._firstMove, options);
        }

        this.trigger("move", moveEvent, options);
        clearTimeout(this._delayDownTimer);
    }

    end(e, options) {
        let endEvent = new EndEvent(e, this);
        this.trigger("end", endEvent, options);

        this.$mover = null;
        this.isActive = false;
        clearTimeout(this._delayDownTimer);
    }

    dragover(dropEvent, options) {
        this.trigger("dragover", dropEvent, options);
    }

    dragout(dropEvent, options) {
        this.trigger("dragout", dropEvent, options);
    }

    createDropEvent(e) {
        let dropEvent = new DropEvent(e, this);
        this.trigger("decorateDrop", dropEvent);
        return dropEvent;
    }

    drop(dropEvent) {
        this.trigger("drop", dropEvent);
    }

    dropEnd(e) {
        let dropEndEvent = new DropEndEvent(e, this);
        this.trigger("dropEnd", dropEndEvent);
    }

    // самое обычное перемещение элемента
    movingElem($elem) {
        this.addElem($elem);

        this.on("start", function(e) {
            let x = parseInt($elem.css("left"));


            let y = parseInt($elem.css("top"));

            e.set("x", x);
            e.set("y", y);
        });

        this.on("move", function(e) {
            $elem.css({
                top: e.start.get("y") + e.dy + "px",
                left: e.start.get("x") + e.dx + "px"
            });
        });
    }

}

// ============
// helpers::

function getActiveDragDrop() {
    let activeDragDrop;
    eachDragDrop(function(dragDrop) {
        if ( dragDrop.isActive ) {
            activeDragDrop = dragDrop;
            return false;
        }
    });
    return activeDragDrop;
}

function hideMovers() {
    eachDragDrop(function(dragDrop) {
        let $mover = dragDrop.$mover;
        if ( !$mover ) {
            return;
        }

        let display = $mover.css("display");
        let style = $mover.attr("style");
        if ( /display\s*:/i.test(style) ) {
            dragDrop._prev_display = display;
        } else {
            dragDrop._prev_display = "";
        }
        $mover.css("display", "none");
    });
}

function showMovers() {
    eachDragDrop(function(dragDrop) {
        let $mover = dragDrop.$mover;
        if ( !$mover ) {
            return;
        }

        $mover.css("display", dragDrop._prev_display);
    });
}

// ============
// global listners

$(document).on("mousedown touchstart", function(e) {
    let hasActiveElem = false;
    if ( e.type == "mousedown" && e.which != 1 ) {
        return;
    }

    eachDragDrop(function(dragDrop) {
        dragDrop._document_onStart(e);

        if ( dragDrop.isActive ) {
            hasActiveElem = true;
        }
    });

    if ( hasActiveElem ) {
        $(document.body).addClass("no-select");
    }
});


// jQuery объекты, над которыми проходит курсор
let overElems = [];
$(document).on("mousemove touchmove", function(e) {
    hideMovers();
    let target = f.getCurrentTarget(e);


    let $target = $(target);

    e.target = target;
    showMovers();

    eachDragDrop(function(dragDrop) {
        dragDrop._document_onMove(e);
    });

    // dragover, dragout, decorateDrop
    let activeDragDrop = getActiveDragDrop();
    if ( !activeDragDrop ) {
        return;
    }

    let newOvers = [];
    let dropEvent = activeDragDrop.createDropEvent(e);

    overElems.forEach(function(dragDrop) {
        let $elem = dragDrop.$elem;


        let elem = $elem && $elem[0];

        if ( !elem ) {
            return;
        }

        if ( elem != target && !$elem.hasChild($target) ) {
            dragDrop.dragout(dropEvent);
        } else {
            newOvers.push(dragDrop);
        }
    });

    eachDragDrop(function(dragDrop) {
        let $elem = dragDrop.$elem;


        let elem = $elem[0];

        if ( !$elem ) {
            return;
        }

        if (
            overElems.indexOf(dragDrop) == -1
                 && (elem == target || $elem.hasChild($target))
        ) {
            newOvers.push(dragDrop);
            dragDrop.dragover(dropEvent);
        }
    });

    overElems = newOvers;
});

$(document).on("mouseup touchend", function(e) {

    hideMovers();
    let target = f.getCurrentTarget(e);


    let $target = $(target);
    e.target = target;
    showMovers();

    let activeDragDrop = getActiveDragDrop();

    if ( activeDragDrop ) {
        let dropEvent;

        let hasDrop = false;
        eachDragDrop(function(dragDrop) {
            if ( dragDrop == activeDragDrop ) {
                return;
            }

            let $elem = dragDrop.$elem;


            let elem = $elem[0];

            if ( !$elem ) {
                return;
            }

            if (
                elem == target
                    || $elem.hasChild($target)
            ) {
                if ( !dropEvent ) {
                    // dropEvent нужно делать здесь,
                    // т.к. "end" срабатывает позже.
                    // иначе простой клик по элементу будет выдавать ошибку
                    dropEvent = activeDragDrop.createDropEvent(e);
                }

                dragDrop.dragout(dropEvent);
                dragDrop.drop(dropEvent);
                hasDrop = true;
            }
        });

        if ( hasDrop ) {
            activeDragDrop.dropEnd(e);
        }
    }

    eachDragDrop(function(dragDrop) {
        dragDrop._document_onEnd(e);
    });

    $(document.body).removeClass("no-select");
});

export default DragDrop;
